// extracted by mini-css-extract-plugin
export default {"configOptionSwatchColor":"ColourSwatch-configOptionSwatchColor-jnG"};